// SingletonFactory.ts
export function createSingleton<T extends new (...args: any[]) => any>(
  TargetClass: T
): T {
  let instance: InstanceType<T> | null = null;

  class SingletonWrapper extends TargetClass {
    constructor(...args: any[]) {
      if (instance) {
        // 기존 인스턴스 반환
        return instance as any; 
      }
      super(...args);
      instance = this as InstanceType<T>;
    }
  }

  // SingletonWrapper를 T 타입으로 단언
  return SingletonWrapper as T; 
}